import { type FilterValues } from "components/filters/FilterContext";
import { mapAppointPhaseFilterToInstruction, mapArtistFilterToInstruction, mapContactFilterToInstruction, mapKeywordFilterToInstruction, mapPeriodFilterToInstruction, mapResponseToAppointmentPhaseFilter, mapResponseToArtistFilter, mapResponseToContactFilter, mapResponseToKeywordFilter, mapResponseToPeriodFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedFlightInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  artistIds: mapArtistFilterToInstruction(filter.artist),
  contactIds: mapContactFilterToInstruction(filter.contact),
  period: mapPeriodFilterToInstruction(filter.period),
  phases: mapAppointPhaseFilterToInstruction(filter.appointmentPhase),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListFlightFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  artist: mapResponseToArtistFilter(response.artists),
  contact: mapResponseToContactFilter(response.contacts),
  period: mapResponseToPeriodFilter(response.period),
  appointmentPhase: mapResponseToAppointmentPhaseFilter(response.phases)
});